import React from 'react';
import {
  useDraggable,
} from '@dnd-kit/core';
import { Button} from '@mui/material';
import PropTypes from 'prop-types';
import { getImageForPath } from '../../../../anwendungskonfigurator/misc/utils';

const DraggableCreateButton = ({ objekt }) => {
  const type = objekt.label
  const { attributes, listeners, setNodeRef } = useDraggable({
    id: `create-${type}`,
    data: { type, isCreator: true }
  });

  return (
    <Button
      ref={setNodeRef}
      {...listeners}
      {...attributes}
      variant="outlined"
      sx={{ 
        m: 1, 
        textTransform: 'none', 
        fontWeight: 'bold', 
        cursor: 'grab',
        touchAction: 'none' 
      }}
      startIcon={<img height="24px" width="24px" src={getImageForPath(objekt.icon)}/>}
    >
      {objekt.longname}
    </Button>
  );
};

DraggableCreateButton.propTypes = {
  type: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
};

export default DraggableCreateButton